import {
  filterFieldCatalogue,
  filterOperatorCatalogue,
  SearchFilter,
  type SearchFilterItem,
} from 'lib-search-ui';
import { memo } from 'react';

import { filterItems } from '../../../../utils/definitions';
import { useSearchQuickFilter } from '../../utils/useSearchQuickFilter';

const items: readonly SearchFilterItem[] = filterItems.status.map(
  ({ id, name }) => ({ value: `${id}`, label: `${name}` }),
);

export const SearchStatusQuickFilter = memo(
  function SearchStatusQuickFilter(): JSX.Element {
    const { condition, handleChange } = useSearchQuickFilter('status');

    return (
      <SearchFilter
        items={items}
        defaultOperator={
          filterOperatorCatalogue.conversations.status.defaultOperator
        }
        selectedValues={condition?.values}
        selectedOperator={condition?.operator}
        onChange={handleChange}
        showSearch={false}
      >
        {filterFieldCatalogue.conversations.status.label}
      </SearchFilter>
    );
  },
);
